function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback } from 'react';
import { Form, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DeleteButton, Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import ElsterFileSection from './ElsterFileSection';
import generalService from '@rd-web-markets/shared/dist/services/claim_groups/general_service';
import { DatePicker, dateToString } from '@rd-web-markets/shared/dist/util/date';
import lastIndex from '@rd-web-markets/shared/dist/util/helpers/lastIndex';
import { generateElsterDocument } from '../../../services/elster_docx/elster_docx_.service';
import elsterDataService from '@rd-web-markets/market/dist/services/elster_docx/elster_data.service';
import { useSelector } from 'react-redux';
const ElsterUploadSection = _ref => {
  let {
    elster,
    setElster
  } = _ref;
  const {
    t
  } = useTranslation();
  const [getElsterData] = elsterDataService.useCrud(elster.id);
  const user = useSelector(state => state.auth.user);
  const deleteFile = useErrorHandling(useCallback(async (elsterId, fileId, elster) => {
    const currentElster = elster.elster_actions.find(elster => elster.id === elsterId);
    await generalService.delete(elsterId, 'elster_actions', 'elster_action_attachments', fileId);
    delete currentElster.file;
    setElster(_objectSpread({}, elster));
  }, [setElster]));
  const changeDate = useErrorHandling(useCallback(async (elsterId, date, elster) => {
    const currentElster = elster.elster_actions.find(elster => elster.id === elsterId);
    const body = {
      elster_action: {
        document_date: date
      }
    };
    const response = await generalService.update(elster.id, 'elsters', 'elster_actions', body, elsterId);
    currentElster.document_date = response.document_date;
    setElster(_objectSpread({}, elster));
  }, [setElster]));
  const updateInvoicePaid = useErrorHandling(useCallback(async (elsterId, elster, e) => {
    const currentElster = elster.elster_actions.find(elster => elster.id === elsterId);
    const body = {
      elster_action: {
        invoice_paid: e.target.checked
      }
    };
    const response = await generalService.update(elster.id, 'elsters', 'elster_actions', body, elsterId);
    currentElster.invoice_paid = response.invoice_paid;
    setElster(_objectSpread({}, elster));
  }, [setElster]));
  const renderDatePicker = elster_action => {
    return /*#__PURE__*/React.createElement(DatePicker, {
      onChange: date => changeDate(elster_action.id, date, elster),
      selected: elster_action.document_date
    });
  };
  const createElster = useErrorHandling(useCallback(async () => {
    const elsterData = await getElsterData();
    generateElsterDocument({
      data: elsterData,
      user
    });
  }, [getElsterData, user]));
  const getElsterPdfDate = elsterPdfDate => {
    if (elsterPdfDate) {
      return dateToString(new Date(elsterPdfDate));
    }
  };
  const tableActions = elster.elster_actions.map((elster_action, index) => {
    var _elster$elster_pdf_fi, _elster_action$file, _elster_action$file2, _elster_action$file3;
    const isElsterFormCreatedRow = elster_action.action_name == 'elster_form_created';
    const documentDate = isElsterFormCreatedRow ? getElsterPdfDate((_elster$elster_pdf_fi = elster.elster_pdf_file) === null || _elster$elster_pdf_fi === void 0 ? void 0 : _elster$elster_pdf_fi.created_at) : renderDatePicker(elster_action);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
      key: 'project_actions' + elster_action.action_name
    }, /*#__PURE__*/React.createElement("td", null, t(elster_action.action_name)), /*#__PURE__*/React.createElement("td", null, documentDate), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ElsterFileSection, {
      elsterId: elster_action.id,
      elster: elster,
      setElster: setElster
    })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
      href: (_elster_action$file = elster_action.file) === null || _elster_action$file === void 0 ? void 0 : _elster_action$file.url,
      target: "_blank",
      rel: "noreferrer"
    }, (_elster_action$file2 = elster_action.file) === null || _elster_action$file2 === void 0 ? void 0 : _elster_action$file2.filename)), /*#__PURE__*/React.createElement("td", null, ((_elster_action$file3 = elster_action.file) === null || _elster_action$file3 === void 0 ? void 0 : _elster_action$file3.filename) && /*#__PURE__*/React.createElement(DeleteButton, {
      style: {
        marginRight: '8px'
      },
      onClick: () => {
        var _elster_action$file4, _elster_action$file5;
        return window.confirm(t("".concat(window.MARKET_CONSTANTS.DELETE_FILE_CONFIRMATION_MESSAGE)) + ": ".concat((_elster_action$file4 = elster_action.file) === null || _elster_action$file4 === void 0 ? void 0 : _elster_action$file4.filename)) && deleteFile(elster_action.id, (_elster_action$file5 = elster_action.file) === null || _elster_action$file5 === void 0 ? void 0 : _elster_action$file5.id, elster);
      },
      "data-testid": "delete_button"
    })), /*#__PURE__*/React.createElement("td", null, isElsterFormCreatedRow && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      onClick: () => {
        createElster(elster);
      },
      className: "ms-auto me-3"
    }, t('create_elster'))))), lastIndex(elster.elster_actions) === index && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t('invoice_paid')), /*#__PURE__*/React.createElement("td", null, elster_action.invoice_paid, /*#__PURE__*/React.createElement(Form.Check, {
      type: "checkbox",
      name: "invoice_paid",
      checked: elster_action.invoice_paid,
      value: elster_action.invoice_paid,
      onChange: e => updateInvoicePaid(elster_action.id, elster, e)
    })), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)));
  });
  if (!elster.elster_actions.length) return /*#__PURE__*/React.createElement("p", {
    className: "ms-4 text-danger"
  }, "please contact admin to add elsters to this section");
  return /*#__PURE__*/React.createElement(Table, {
    size: "sm",
    style: {
      marginLeft: '20px'
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, t('action')), /*#__PURE__*/React.createElement("th", null, t('date')), /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null)), tableActions));
};
export default ElsterUploadSection;